import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en.json';
import zhTranslation from './locales/zh.json';

// 资源对象
const resources = {
  en: {
    translation: enTranslation
  },
  zh: {
    translation: zhTranslation
  }
};

// 获取用户优先语言
const getBrowserLanguage = (): string => {
  const lang = navigator.language.split('-')[0];
  return ['en', 'zh'].includes(lang) ? lang : 'en';
};

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
    returnEmptyString: false;
    allowObjectInHTMLChildren: true;
  }
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || getBrowserLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    returnNull: false,
    returnEmptyString: false
  });

export default i18n; 